import { render, staticRenderFns } from "./EditAnggota.vue?vue&type=template&id=d533d722&scoped=true&"
import script from "./EditAnggota.vue?vue&type=script&lang=js&"
export * from "./EditAnggota.vue?vue&type=script&lang=js&"
import style0 from "./EditAnggota.vue?vue&type=style&index=0&id=d533d722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d533d722",
  null
  
)

export default component.exports